import { Component, EventEmitter , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { DropDownsService } from "../../services/dropdowns.service";
import { IDropDownView } from "../../interfaces/idropdowns";
import { IButton } from "../../interfaces/ibuttons";
import { EmitterService } from "../../services/emitter.service";


@Component({
    selector: "dropdownsoverview",
    templateUrl: "./dropdownsoverview.component.html",
    standalone: true,
    imports: [CommonModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class DropDownsOverviewComponent {
    dropDowns: IDropDownView[];
    headerButtons: IButton[];

    constructor(private activatedRoute: ActivatedRoute, private dropDownsService: DropDownsService, private router: Router) {
        this.dropDowns = activatedRoute.snapshot.data["dropDowns"] as IDropDownView[];
    }

    editClicked(dropDown: IDropDownView): void {
        this.router.navigate(["/dropdown", dropDown.id]);
    }

    add(): void {
        this.router.navigate(["/dropdown"]);
    }
}


